export const FROM_FORCED_SSO_KEY = 'fromForcedSso';
export const FROM_FORCED_SSO_FLAG = 'fromForcedSsoFlag';
